import { render, staticRenderFns } from "./DesignationDonations.vue?vue&type=template&id=70955eb6&scoped=true"
import script from "./DesignationDonations.vue?vue&type=script&lang=js"
export * from "./DesignationDonations.vue?vue&type=script&lang=js"
import style0 from "./DesignationDonations.vue?vue&type=style&index=0&id=70955eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70955eb6",
  null
  
)

export default component.exports